/* unplugin-vue-components disabled */import script from "./interactive.vue?vue&type=script&lang=js"
export * from "./interactive.vue?vue&type=script&lang=js"

import "./interactive.vue?vue&type=style&index=0&id=4b116773&lang=scss"

const __exports__ = script;

export default __exports__